const faqs = [
    { 
        id: 1, 
        heading: 'How do I register for the event?',
        content: 'You can easily register for the event through our website by visiting the registration page. Simply provide your details, select your ticket type, and complete the payment process.',
    }, 
    { 
        id: 2,
        heading: 'What ticket options are available?',
        content: 'We offer various ticket types including Standard, VIP, and Group Passes. Each ticket type offers different perks, and you can select the one that suits your needs during registration.',
    },
    {
        id: 3, 
        heading: 'What is your cancellation policy?',
        content: 'You can cancel your registration up to 7 days before the event for a full refund. Cancellations made after this period may incur a fee, depending on the ticket type.',
    },
    {
        id: 4,
        heading: 'Where can I find the event schedule?',
        content: 'The full event schedule is available on our website under the "Agenda" section. You can view the detailed program, including keynote sessions, workshops, and networking opportunities.',
    },
    {
        id: 5,
        heading: 'Are there accommodation options available?',
        content: 'Yes, we have partnered with nearby hotels to offer special rates for our attendees. You can find the list of recommended accommodations and booking details in the "Venue & Hotels" section of our website.',
    },
];

export default faqs;